/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

document.addEventListener('theme:cart:change', function () {
  fetch('/cart.js')
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to retrieve cart');
      }
      return response.json();
    })
    .then(function (cart) {
      var cartItems = cart.items.map(function (item) {
  return {
    ProductName: item.product_title,
    VariantID: item.variant_id,
    Size: item.variant_title,
    Quantity: item.quantity,
    Price: item.final_price / 100,
    ImageURL: item.image,
    ProductURL: window.location.origin + item.url
  };
});
// Send the complete cart to Klaviyo
console.log('FULL CART TRACKING REACHED:', cartItems.length);
console.log('KLAVIYO FUNCTION CHECK:', typeof window.klaviyo?.track);
if (window.klaviyo && typeof window.klaviyo.track === 'function') {
  // Klaviyo full cart tracking - November 3, 2026
  console.log('KLAVIYO TRACK CALL STARTING');
var trackingResult = window.klaviyo.track('Sydney’s Closet Full Cart Updated', {
    Items: cartItems,
    ItemCount: cart.item_count,
    CartTotal: cart.total_price / 100,
    Currency: cart.currency,
    $value: cart.total_price / 100
});
console.log('KLAVIYO RETURN VALUE:', trackingResult);
trackingResult.then(function(result) {
  console.log('KLAVIYO FINAL RESULT:', result);
}).catch(function(error) {
  console.error('KLAVIYO FINAL ERROR:', error);
});
}
    })
    .catch(function (error) {
      console.error('Cart tracking test:', error);
    });
});
  // ^^ Keep your scripts inside this IIFE function call



  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
